// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Icon,
  Image,
  Grid,
  Container,
  Card,
  Button,
  Embed,
  Segment,
  Dimmer
} from 'semantic-ui-react'
import wp from '../assets/newwp.png'
import sheet from '../assets/newsheet.png'
import FeatureBlock from './FeatureBlock'
import bgimg from '../assets/herobg.png'

export default class Features extends Component {
  constructor (props) {
    super(props)
    this.state = {
      video: false
    }
  }

  video = () => {
    this.setState({
      video: true
    })
  }

  handleOnDragStart = (e) => {
    e.preventDefault()
  }

  render () {
    let { video } = this.state
    return (
      <Container className='mts mb'>
        <div className='center mb mts'>
          {/* <div className='mb'>
            <h3>Take advantage of our pre-built components</h3>
          </div> */}

          <Grid stackable verticalAlign='top' centered>
            <FeatureBlock icon='text height' text='Structured Text' />
            <FeatureBlock icon='video play' text='YouTube/Video' />
            <FeatureBlock icon='image' text='Image' />
            <FeatureBlock icon='sound' text='Audio Player' />
            <FeatureBlock icon='lightbulb outline' text='Smart Button' />
            <FeatureBlock icon='chrome' text='Webview' />
            <FeatureBlock icon='list alternate outline' text='List View' />
            <FeatureBlock icon='map marker alternate' text='Embed Map' />
            <FeatureBlock icon='mail outline' text='Contact info' />
            <FeatureBlock icon='google' text='AdMob Banner' />
            <FeatureBlock icon='rss' text='RSS Feed' />
            <FeatureBlock icon='area graph' text='Charts' />
          </Grid>
        </div>

        <br clear='all' />

        <div className='center mb'>
          <h3>Extensions</h3>
        </div>
        <div className='dashboard'>
          <Grid centered stackable verticalAlign='middle'>
            <Grid.Column width='5'>
              <Image size='medium' centered src={wp} />
            </Grid.Column>
            <Grid.Column width='5'>
              <Segment padded='very' basic>
                <Image
                  style={{ height: '40px' }}
                  src='https://s26271.pcdn.co/wp-content/uploads/wordpress.png'
                />
                <h4>
                  <b>WordPress</b>
                </h4>
                <div className='mtbs'>
                  <p>
                    Convert your blog to iOS and Android mobile app in seconds. No configuration
                    needed.
                  </p>
                </div>
                <div>
                  <Button color='black' size='small' basic href='/wordpress'>
                    Learn more
                  </Button>
                </div>
              </Segment>
            </Grid.Column>
          </Grid>
        </div>

        <div className='dashboard'>
          <Grid centered stackable verticalAlign='middle'>
            <Grid.Column width='5'>
              <Segment padded='very' basic>
                <Image
                  style={{ height: '40px' }}
                  src='https://seeklogo.com/images/G/google-sheets-logo-70C2B2CA6A-seeklogo.com.png'
                />
                <h4>
                  <b>Google Sheets</b>
                </h4>
                <div className='mtbs'>
                  <p>
                    Turns CSV spreadsheets into user-friendly apps with few clicks - instant
                    updates!
                  </p>
                </div>
                <div className='mt'>
                  <Button color='black' size='small' basic href='/signup'>
                    Learn more
                  </Button>
                </div>
              </Segment>
            </Grid.Column>
            <Grid.Column width='5'>
              <Image size='medium' centered src={sheet} />
            </Grid.Column>
          </Grid>
        </div>

          <div className='center mt'>
            {video ? (
              <Embed id='GCF3MM-VQLI' source='youtube' mute />
            ) : (
              <Button.Group>
                <Button color='black' size='medium' onClick={this.video} icon labelPosition='left'>
                  <Icon name='play' />
                  Watch walktrough video
                </Button>
                <Button color='black' basic size='medium' href='/pricing'>
                  Pricing
                </Button>
              </Button.Group>
            )}
          </div>

      </Container>
    )
  }
}
